import { capitalize } from 'lodash';
import React from 'react';
import { ethers } from 'ethers';
import { tokenDecimals } from '../../../helpers/config/contracts.config';
import { formatCurrencyAmount } from '../../../helpers/formatters';
import { IWithdrawal } from '../../../services/api/api.interfaces';
import { getStatusClass } from '../helpers/activity-columns';


interface IWithdrawalSmallTableRowProps {
    withdrawal: IWithdrawal;
}

const WithdrawalSmallTableRow: React.FC<IWithdrawalSmallTableRowProps> = ({ withdrawal }) => {

    let [date, time] = withdrawal.createdAt.split('T');
    time = time?.split('.')[0];


    return (
        <div className="WithdrawalSmallTableRow p-2.5 card-container mb-1">
            <div className="flex mb-1 justify-between nereus-color-white nereus-body">
                <span>Withdrawal</span>
                <span>{formatCurrencyAmount(ethers.utils.formatUnits(withdrawal.amount, tokenDecimals.usdt), 'USDT')}</span>
            </div>
            <div className="flex justify-between nereus-caption">
                <span className="nereus-color-neutral-grey">{date}, {time}</span>
                <span className={getStatusClass(withdrawal.status)}>{capitalize(withdrawal.status)}</span>
            </div>
        </div>
    );
};

export default WithdrawalSmallTableRow;
